import { Button, ButtonProps } from "@komplett/design-system";
import classNames from "classnames";
import React from "react";

interface BuyButtonI {
	label: string;
	className?: string;
	variant?: ButtonProps["variant"];
	loading?: boolean;
	onClickHandler: () => void;
	tabIndex?: number | undefined;
}

const BuyButton = ({
	label,
	className,
	variant = "primary",
	loading,
	onClickHandler,
	tabIndex,
}: BuyButtonI) => (
	<Button
		aria-label={label}
		className={classNames("addtocart-button", className)}
		variant={variant}
		size="sm"
		loading={loading}
		onClick={onClickHandler}
		tabIndex={tabIndex}
	>
		<span dangerouslySetInnerHTML={{ __html: label }}></span>
	</Button>
);

export default BuyButton;
